export function UsageMeterRow({ label, current, max, isLast }: {
  label: string;
  current: number;
  max: number;
  isLast?: boolean;
}) {
  const limitReached = max > 0 && current >= max;
  const percent = max > 0 ? Math.min(100, (current / max) * 100) : 0;

  return (
    <div className={ `flex items-center gap-4 px-5 py-4 ${isLast ? `` : `border-b border-gray-100`}` }>
      <div className={ `w-28 text-sm font-semibold text-paidniceGreen-800` }>{ label }</div>
      <div className={ `h-1.5 flex-1 rounded-full bg-gray-200` }>
        <div
          className={ `h-1.5 rounded-full ${limitReached ? `bg-amber-600` : `bg-paidniceGreen-600`}` }
          style={ { width: `${percent}%` } }
        />
      </div>
      <div className={ `w-28 text-right text-sm ${limitReached ? `font-semibold text-amber-700` : `text-gray-500`}` }>
        { `${current} / ${max}` }
      </div>
    </div>
  );
}
